import React, { useMemo } from 'react';
import { Card, Button } from 'antd';
import styles from './s.module.less';
import { IClosedFunnelBasicInfo, IClosedFunnelDetail } from 'types/operation';

export interface InfoCardProps {
    info?: IClosedFunnelDetail;
    onEdit?: () => void;
}

const InfoCard: React.FC<InfoCardProps> = ({ info, onEdit }) => {
    const { name, states, type, typeValues, link } = useMemo(() => {
        return info?.basicInfo || {} as IClosedFunnelBasicInfo;
    }, [info]);

    return (
        <Card className={styles.infoCard} bordered={false}>
            <div className={styles.header}>
                <span className={styles.title}>Funnel information</span>
                <Button onClick={onEdit}>Edit</Button>
            </div>
            <div className={styles.item}>
                <div className={styles.label}>Funnel name</div>
                <div className={styles.value}>{name}</div>
            </div>
            <div className={styles.item}>
                <div className={styles.label}>Applicable states</div>
                <div className={styles.value}>{states}</div>
            </div>
            <div className={styles.item}>
                <div className={styles.label}>Type</div>
                <div className={styles.value}>{type}</div>
            </div>
            <div className={styles.item}>
                <div className={styles.label}>Condition</div>
                <div className={styles.value}>{typeValues}</div>
            </div>
            <div className={styles.item}>
                <div className={styles.label}>Link</div>
                <div className={styles.value}>{link}</div>
            </div>
        </Card>
    );
};

export default InfoCard;
